<template>
    <text-field
        :value="value"
        :append-icon="passwordVisible ? 'visibility_off' : 'visibility'"
        :type="passwordVisible ? 'text' : 'password'"
        :error-messages="errorMessages"
        :label="label"
        :disabled="disabled"
        :tabindex="tabindex"
        @click:append="passwordVisible = !passwordVisible"
        @input="$emit('input', $event)"
    />
</template>

<script>
import { ref } from "@vue/composition-api";

export default {
    name: "PasswordField",
    props: {
        errorMessages: {
            type: [String, Array],
            default: () => []
        },
        bindProps: {
            type: Object,
            default: null
        },
        value: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        tabindex: {
            type: [String, Number],
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const passwordVisible = ref(false)

        return {
            passwordVisible
        }
    }
}
</script>

<style scoped lang="scss">
.v-input ::v-deep .v-input__append-inner {
    margin-top: 9px !important;
    margin-right: 8px !important;
}
</style>